import PropTypes from 'prop-types'
import get from 'lodash/get'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from '@everlane/button'
import { isInGDPRCountry } from 'base/lib/config'
import LoadingAnimation from 'base/react/components/loading_animation'
import SiteLocation from 'base/constants/site_location'
import Input from 'base/react/components/form/input'
import Radio from 'base/react/components/form/radio'
import Cookies from 'js-cookie'
import { SHOW_GDPR_EMAIL_OPTIN } from 'cookies.yml'

export class SignUpForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    errors: PropTypes.object,
    initialEmail: PropTypes.string,
    password: PropTypes.string,
    defaultOptIn: PropTypes.bool,
    siteLocation: PropTypes.string,
  }

  static defaultProps = {
    initialEmail: '',
    errors: {},
    defaultOptIn: true,
  }

  state = {
    email: this.props.initialEmail,
    password: this.props.password,
    full_name: '',
    gender: get(this.props, 'visitor.gender', ''),
    optIntoEmails: this.props.defaultOptIn,
  }

  // Lifecycle

  componentDidMount() {
    if (this.props.initialEmail?.length) {
      this.passwordInput.getInputRef().focus()
    } else {
      this.emailInput.getInputRef().focus()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.password !== this.props.password) {
      this.setState({ password: this.props.password })
    }
  }

  // Event Handling

  handleSubmit = event => {
    event.preventDefault()

    this.props.onSubmit &&
      this.props.onSubmit({
        email: this.state.email,
        password: this.state.password,
        full_name: this.state.full_name,
        gender: this.state.gender,
        email_optout: this.state.optIntoEmails ? undefined : true,
      })
  }

  // Rendering

  renderEmailField() {
    return (
      <Input
        errorPosition="bottom"
        error={this.props.errors.email}
        placeholder="Email address"
        autoComplete="email"
        type="email"
        value={this.state.email}
        ref={input => (this.emailInput = input)}
        onChange={() => this.setState({ email: this.emailInput.getValue() })}
      />
    )
  }

  renderPasswordField() {
    return (
      <Input
        errorPosition="bottom"
        error={this.props.errors.password}
        autoComplete="password"
        type="password"
        name="password"
        placeholder="Password"
        value={this.state.password}
        ref={input => (this.passwordInput = input)}
        onChange={() =>
          this.setState({
            password: this.passwordInput.getValue(),
          })
        }
      />
    )
  }

  renderFullNameField() {
    const error = this.props.errors.full_name
      ? Object.values(this.props.errors.full_name).join(', ')
      : null

    return (
      <Input
        label="Full Name"
        error={error}
        autoComplete="name"
        name="fullName"
        placeholder="Annie Clark"
        type="text"
        value={this.state.full_name}
        ref={input => (this.fullNameInput = input)}
        onChange={() => this.setState({ full_name: this.fullNameInput.getValue() })}
      />
    )
  }

  renderGenderPicker() {
    const { gender } = this.state
    return (
      <div className="login__radio">
        <p className="login__radio-header">What styles are you interested in?</p>
        <Radio
          checked={gender === 'female'}
          onChange={() => this.setState({ gender: 'female' })}
          radioId="female"
        >
          <label htmlFor="female" className="login__radio-label">
            Women
          </label>
        </Radio>
        <Radio
          checked={gender === 'male'}
          onChange={() => this.setState({ gender: 'male' })}
          radioId="male"
        >
          <label htmlFor="male" className="login__radio-label">
            Men
          </label>
        </Radio>
      </div>
    )
  }

  renderOptOutEmailFieldset() {
    return (
      <div
        onClick={() => {
          this.setState({ optIntoEmails: !this.state.optIntoEmails })
        }}
      >
        <Input
          type="checkbox"
          labelClass="gdpr__opt-out-checkbox--label"
          label="I’d like to get notified about new products, special events, and early access to products. I can unsubscribe at any time."
          value={this.state.optIntoEmails}
          name="optOutOfEmails"
        />
      </div>
    )
  }

  render() {
    const buttonText = isInGDPRCountry() ? 'Sign Up' : `Unlock 20% off `
    return (
      <form disabled={this.props.isLoading} onSubmit={this.handleSubmit}>
        {this.renderEmailField()}
        {this.renderPasswordField()}
        {Cookies.get(SHOW_GDPR_EMAIL_OPTIN) === 'true' &&
          this.props.siteLocation !== SiteLocation.DESKTOP_HOMEPAGE_MODAL &&
          this.renderOptOutEmailFieldset()}
        {this.props.isLoading && <LoadingAnimation style={{ marginTop: 5 }} />}
        {!this.props.isLoading && (
          <Button
            type="submit"
            className="flat-button--full-width"
            style={{ marginTop: 5 }}
            variant="rectangle"
            dark
          >
            {buttonText}
          </Button>
        )}
      </form>
    )
  }
}

function mapStateToProps(state) {
  return {
    visitor: state.session.visitor,
  }
}

export default connect(mapStateToProps)(SignUpForm)
